module.exports = __webpack_public_path__ + "static/img/CEE_A.ed7729b2.jpg";